import fb from "../firebase";
import {Tarefa} from "../../models/Tarefa";
import {DateTime} from "luxon";
import {useFirestore, UseFirestoreOptions} from "./useFirestore";


// TODO: review logica com args temporais
export const useAgendaProximos = (args: {userId: string, inicio: DateTime, fim: DateTime}, options?: UseFirestoreOptions): [Tarefa[], boolean] => {
  const {userId, inicio, fim} = args;

  return useFirestore({
    args,
    queryKey: `useAgendaProximos:${userId}:${inicio}:${fim}`,
    query: ({userId, inicio, fim}) => fb.db.collection('agenda')
      .where('owner', '==', userId)
      .where('concluido', '==', false)
      .where('data', '>=', inicio.toJSDate())
      .where('data', '<=', fim.toJSDate())
      .orderBy('data', 'asc'),
    options,
  });
};
